module.exports = {"450203001":"天马街道","450203002":"驾鹤街道","450203003":"箭盘山街道","450203004":"五里亭街道","450203005":"荣军街道","450203006":"白莲街道","450203007":"麒麟街道","450203008":"阳和街道","450203100":"雒容镇","450203101":"洛埠镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450203.json
// module id = 1908
// module chunks = 0